import React from "react";
import { FaTimes } from "react-icons/fa";

const EmailViewModal = ({ open, handleClose, emailData }) => {
  if (!open || !emailData) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={handleClose}
    >
      <div
        className="relative w-[90%] max-w-[900px] bg-white rounded-2xl shadow-2xl p-6 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 transition"
        >
          <FaTimes className="text-xl" />
        </button>

        {/* Header */}
        <h2 className="text-xl font-semibold text-[#1d2951] mb-3">
          {emailData.subject || "No Subject"}
        </h2>

        <p className="text-sm text-gray-500 mb-2">
          <span className="font-medium text-gray-700">From:</span> {emailData.sender}
        </p>

        <p className="text-sm text-gray-500 mb-4">
          <span className="font-medium text-gray-700">Date:</span>{" "}
          {new Date(emailData.ts).toLocaleString()}
        </p>

        {/* Email Body (HTML) */}
        <div
          className="border-t border-gray-300 pt-4 text-sm text-gray-800 leading-relaxed break-words"
          dangerouslySetInnerHTML={{ __html: emailData.body }}
        ></div>
      </div>
    </div>
  );
};

export default EmailViewModal;
